import React from 'react';
import { injectIntl } from 'react-intl';

import './UserRowShimmer.scss';

class UserRowShimmer extends React.Component {
	constructor(props) {
    super(props);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }



  render() {
  	return (
  		<tr className="user-row__row">
        <td className="user-row__checkbox">
          <span className="checkbox-cell"></span>
        </td>
        <td className="user-row__owner-cell">
          <span className="general-cell"/>
        </td>
        <td className="user-row__user-role">
          <span className="general-cell"/>
        </td>
        <td className="user-row__status-cell">
          <span className="general-cell"/>
        </td>
        <td className="user-row__departments-wrap">
          <span className="general-cell"/>
        </td>
        <td className="user-row__departments-wrap">
         <span className="general-cell"/>
        </td>
        <td className="user-row__departments-wrap">
          <span className="general-cell"/>
        </td>
        <td className="user-row__departments-wrap">
         <span className="general-cell"/>
        </td>
        <td className="user-row__departments-wrap">
          <span className="general-cell"/>
        </td>
      </tr>
  	);
  }

}

UserRowShimmer.propTypes = {
  //notifyUserSelected: PropTypes.func.isRequired,
};

export default injectIntl(UserRowShimmer);

